import { MutationTree } from 'vuex'
import { EmployeesSelect } from './types'
import Employee from '@/calendesk/models/DTO/Response/Employee'

export const mutations: MutationTree<EmployeesSelect> = {
  SET_EMPLOYEES (state, payload: Employee[]) {
    state.employees = payload
  }
}
